import React, { useState, useEffect, memo } from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import useWindowSize from '../../hooks/useWindowSize'

import {
  cardsWithIconsOuterContainer,
  cardsWithIconsInnerContainer,
  cardsWithIconsColumnContainer,
  cardsWithIconsHeadingContainer,
  cardsWithIconsColumn,
  cardsWithIconsDark,
  cardsWithIconsTextContainer,
  cardsWithIconsImageContainer,
  cardsWithIconsAltDisplay,
  cardsWithIconsNormalImageContainer,
  cardsWithIconsFourColumns,
  cardsWithIconsCTA,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const CardsWithIcons = ({
  title,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
  alternateDisplayMode,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000000' : '#F8F8F8'
  const size = useWindowSize()
  const [isTablet, setIsTablet] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const LinkWrapper = ({ url, children }) => {
    return url ? <Link to={url}>{children}</Link> : <>{children}</>
  }

  /**
   * gridClass
   * @param {*} components
   * @param {*} isTablet
   * @param {*} isMobile
   * @returns object
   * This func returns the 2 intergers that will split the
   * grid with the higher number on top and lower number on
   * bottom. 2 x 2 on tablet and 1 column on mobile
   */
  const gridClass = (components, isTablet, isMobile) => {
    let low = components.length <= 3 ? 0 : Math.floor(components.length / 2)
    let high =
      components.length <= 3
        ? components.length
        : Math.ceil(components.length / 2)
    const fr = '1fr '
    low = low >= 3 ? 2 : low
    const row = isMobile
      ? `${fr.repeat(1)}`
      : isTablet
      ? `${fr.repeat(2)}`
      : `${fr.repeat(low)}`
    const column = isMobile
      ? `${fr.repeat(1)}`
      : isTablet
      ? `${fr.repeat(2)}`
      : `${fr.repeat(high)}`
    const grid = {
      rows: row,
      columns: column,
    }
    return grid
  }

  useEffect(() => {
    setIsTablet(size.width <= 834 && size.width >= 510)
    setIsMobile(size.width <= 510)
  }, [size.width])

  const gridStyles = gridClass(components, isTablet, isMobile)

  return (
    <div
      className={[
        isDarkTheme ? cardsWithIconsDark : '',
        alternateDisplayMode ? cardsWithIconsAltDisplay : '',
      ].join(' ')}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', cardsWithIconsOuterContainer].join(' ')}>
        <div className={['container', cardsWithIconsInnerContainer].join(' ')}>
          {(hideTitle === null || hideTitle === false) && (
            <div className={cardsWithIconsHeadingContainer}>
              <h2>{title}</h2>
            </div>
          )}
          <div
            className={cardsWithIconsColumnContainer}
            style={{
              gridTemplateColumns: gridStyles.columns,
              gridTemplateRows: gridStyles.rows,
            }}
          >
            {components &&
              components.map(
                ({ ctaText, ctaUrl, subtitle, title, image }, index) => {
                  return (
                    <div className={cardsWithIconsColumn} key={index}>
                      <div className={cardsWithIconsTextContainer}>
                        {image &&
                          (isSvgOrGif(image.file.url) ? (
                            <div
                              className={[
                                cardsWithIconsImageContainer,
                                cardsWithIconsNormalImageContainer,
                              ].join(' ')}
                            >
                              <Link to={ctaUrl}>
                                <img
                                  src={image.file.url}
                                  style={{
                                    height:
                                      image.file.details.image.height >
                                      image.file.details.image.width
                                        ? '100%'
                                        : '',
                                  }}
                                />
                              </Link>
                            </div>
                          ) : (
                            <div className={cardsWithIconsImageContainer}>
                              <Link to={ctaUrl}>
                                <GatsbyImage
                                  image={getImage(image.cardsWithIconsIcon)}
                                  objectFit="contain"
                                />
                              </Link>
                            </div>
                          ))}
                        {title && (
                          <h3>
                            {<LinkWrapper url={ctaUrl}>{title}</LinkWrapper>}
                          </h3>
                        )}
                        {subtitle && (
                          <p>
                            <LinkWrapper url={ctaUrl}>
                              {subtitle.subtitle}
                            </LinkWrapper>
                          </p>
                        )}
                        {ctaText && ctaUrl && (
                          <div className={cardsWithIconsCTA}>
                            <Link to={ctaUrl}>{ctaText}</Link>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardsWithIcons
